import * as React from 'react';
import ProductCard from '../ProductCard/ProductCard';
import IndividualCard from '../IndividualCard/IndividualCard';
import FlyersCaServiceInstance from 'src/services/products/FlyersCaService';
import listService from 'src/services/lists/ListsService';
import './FlyersCa.scss';
import env from 'src/shared/env';
import { first } from 'lodash';
import i18n from 'src/translation/i18n';
import id from 'date-fns/esm/locale/id/index.js';
import ProductCardLoading from 'src/components/common/ProductCardLoading';
import { goToPartDetail} from 'src/utils/navigation';

interface IFlyersCa {
  isLoading: boolean;
  products: [];
  priceList: any[];
  cooking: [];
  dishwasher: [];
  washer: [];
  dryer: [];
  hosesandconnectoer: [];
  earnmoreonservicecalls: [];
  christmasSpecials: [];
  refrigerator: [];
  installation: [];
  applianceCleaners: [];
  bannerImageURL: string;
  flyerClassPoistion: string;
  batchSize: number;
  batchIndex: number;
  hasMore: boolean;
  isProductDetailsLoading: boolean;
  isFavoriteLoading:boolean;
  selectedFavoriteItem: string;
  batchEnd: number;
}

class FlyersCa extends React.Component<any, IFlyersCa> {
  private BannerEnURL: string = `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/flyer.jpg`;
  private BannerFrURL: string = `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/flyer-fr.jpg`;
  private GraphicBgURL: string = `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/graphic.svg`;
  public individualCards: any[];
  private today = new Date();
  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: true,
      products: [],
      priceList: [],
      cooking: [],
      dishwasher: [],
      washer: [],
      dryer: [],
      hosesandconnectoer: [],
      earnmoreonservicecalls: [],
      christmasSpecials: [],
      refrigerator: [],
      installation: [],
      applianceCleaners: [],
      bannerImageURL: '',
      flyerClassPoistion: '',
      batchSize: 10,
      batchIndex: 0, 
      hasMore: true,
      isProductDetailsLoading: false,
      isFavoriteLoading: false,
      selectedFavoriteItem:'',
      batchEnd:0
    };
    this.individualCards = [
      {
        label: `${i18n.t('flyers.viewAllCookingParts')}`,
        imageUrl: `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/parts1.png`,
        buttonText: `${i18n.t('flyers.explore')}`,
        backgroundURl: `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/color1@2x.png`,
        cardName: 'firstCard',
        buttonLink: `${env.REACT_APP_BASE_WORDPRESS_URL}content/#/categories/61/189`
      },
      {
        label: `${i18n.t('flyers.seeAllCleanersHere')}`,
        imageUrl: `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/cleaner.png`,
        buttonText: `${i18n.t('flyers.explore')}`,
        backgroundURl: `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/color2@2x.png`,
        cardName: 'secondCard',
        buttonLink: `${env.REACT_APP_BASE_WORDPRESS_URL}content/#/categories/69/267`
      },
      {
        label: `${i18n.t('flyers.moreHosesAvailableHere')}`,
        imageUrl: `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/hose.png`,
        buttonText: `${i18n.t('flyers.explore')}`,
        backgroundURl: `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/color3@2x.png`,
        cardName: 'thirdCard',
        buttonLink: `${env.REACT_APP_BASE_WORDPRESS_URL}content/#/categories/68/249`
      }
      // {
      //     label: 'View all cooking parts',
      //     imageUrl: `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/color4@2x.png`,
      //     buttonText: 'Buy from $100',
      //     backgroundURl: `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/cleaner.png`,
      //     cardName: 'fourthCard'
      // },
      // {
      //     label: 'See all cleaners here',
      //     imageUrl: `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/color5@2x.png`,
      //     buttonText: 'Buy Now',
      //     backgroundURl: `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/cleaner.png`,
      //     cardName: 'fifthCard'
      // },
      // {
      //     label: 'More hoses available here',
      //     imageUrl: `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/color6@2x.png`,
      //     buttonText: 'Buy Now',
      //     backgroundURl: `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme-canada/inc/assets/imgs/flyer/cleaner.png`,
      //     cardName: 'sixthCard'
      // }
    ];
  }

  public getProducts = () => {
    setTimeout(() => {
    FlyersCaServiceInstance.getProducts().then(res => {
      const selectedParameters: any[] = [];
      if (!Array.isArray(res) || res.length === 0) {
        this.setState({
          isProductDetailsLoading: false,
          hasMore: false
        });
      }  
      res.forEach((a: any) => {
        if (
          (Boolean(a.acf.isactive) || Number(a.acf.isactive) === 1) &&
          a.acf.product_position === 'center' &&
          this.props.location.pathname === '/flyers-ca/center'
        ) {
          selectedParameters.push(a);
        } else if (
          (Boolean(a.acf.isactive) || Number(a.acf.isactive) === 1) &&
          a.acf.product_position === 'right' &&
          this.props.location.pathname === '/flyers-ca/right'
        ) {
          selectedParameters.push(a);
        } else if (
          (Boolean(a.acf.isactive) || Number(a.acf.isactive) === 1) &&
          a.acf.product_position === 'left' &&
          this.props.location.pathname === '/flyers-ca/left'
        ) {
          selectedParameters.push(a);
        }
      });
      this.getPriceList(selectedParameters,'MAIN');
      this.setState({
        products: res
      });
    });
  }, 1000);
  };

  private getPriceList = (product: any, frm:any) => {
    if (this.state.isProductDetailsLoading || this.state.hasMore===false){
      return;

    } 
    const { batchIndex, batchSize } = this.state;
    let start=0;
    let end=0;
    if(frm==="TOGGLEFAVORITE"){
      start=0;
      end=this.state.batchEnd;
      this.setState({ isProductDetailsLoading: false });

    }else{
      start = batchIndex * batchSize;
      end= start + batchSize;
      this.setState({ isProductDetailsLoading: true });
    }
    // const start = batchIndex * batchSize;
    // const end = start + batchSize;
    const batchParts = product.slice(start, end);
    this.setState({ batchEnd: end });
    if (batchParts.length === 0) {
      this.setState({ hasMore: false, isProductDetailsLoading: false });
      return;
    }

    const parameters: any = batchParts.map((parameter: any) => {
      return {
        manufacturerCode: parameter.acf.product_mfc,
        productNumber: parameter.acf.product_name
      };
    });
    
    if(frm==="TOGGLEFAVORITE"){
      FlyersCaServiceInstance.getPriceList(parameters, product, start, end).then((details) => {
        this.setState((prevState) => ({
          priceList:details,
          batchIndex: prevState.batchIndex,
          isProductDetailsLoading: false,
          isFavoriteLoading: false
        }));
      })
      .catch(() => this.setState({ isProductDetailsLoading: false }));
    }else{
      FlyersCaServiceInstance.getPriceList(parameters, product, start, end).then((details) => {
        this.setState((prevState) => ({
          priceList: [...prevState.priceList, ...details],
          batchIndex: prevState.batchIndex + 1,
          isProductDetailsLoading: false,
          isFavoriteLoading: false
        }));
      })
      .catch(() => this.setState({ isProductDetailsLoading: false }));

    }
    /* FlyersCaServiceInstance.getPriceList(parameters, product).then(
      priceList => {
        this.filterSections(priceList);
        this.setState({
          priceList,
          isLoading: false
        });
        this.scrollspy();
      }
    ); */
  };

  public handleBuyNow = (endpoint: string) => {
    // console.log('i18n.language>>>' + `${i18n.language}`);
    // console.log(
    //   'env.REACT_APP_BASE_WORDPRESS_URL>>>' +
    //     `${env.REACT_APP_BASE_WORDPRESS_URL}`
    // );
    let endpointStr = endpoint;
    if (i18n.language === 'fr-CA') {
      endpointStr = endpointStr.replace('/ca/', 'fr/');
    }
    if (i18n.language === 'en-CA') {
      endpointStr = endpointStr.replace('/ca/', 'en/');
    }
    window.location.assign(`${env.REACT_APP_BASE_WORDPRESS_URL}${endpointStr}`);
    window.scrollTo(0, 0);
  };

  private handleToggleFavorite = (
    name: string,
    category:string,
    mfc: string,
    favorite: boolean,
    favoriteId: number
  ) => {
    if (favorite) {
      this.setState({ isFavoriteLoading: true,selectedFavoriteItem: name });
      listService.deleteItem(favoriteId).then(res => {
        this.setState({ hasMore: true, isProductDetailsLoading: false });
        this.getPriceList(this.state.products, 'TOGGLEFAVORITE');
      }).catch(error => {
        console.error("Failed to delete item:", error);
        this.setState({ isFavoriteLoading: false }); 
      });
    } else {
      if(category?.trim() === "WSER") {
        goToPartDetail(`${mfc}  ${name}`);
        return;
      }
      this.setState({ isFavoriteLoading: true,selectedFavoriteItem: name });
      listService
        .addItem('favorites', name, mfc)
        .then(res => {
        this.setState({ hasMore: true, isProductDetailsLoading: false });
        this.getPriceList(this.state.products, 'TOGGLEFAVORITE')
        }
        ).catch(error => {
          console.error("Failed to add item:", error);
          this.setState({ isFavoriteLoading: false });
        });
    }
  };

  // Dynamic landingpage flyerbanner
  public getFlyBanners = () => {
    const currentDate =
      this.today.getDate() +
      '/' +
      (this.today.getMonth() + 1) +
      '/' +
      this.today.getFullYear();
    FlyersCaServiceInstance.getFlyerBanner().then(res => {
      res.forEach((a: any) => {
        if (i18n.language === 'en-CA') {
          if (
            a.acf.isactive &&
            a.acf.issalelive === 'Yes' &&
            a.acf.startdate <= currentDate &&
            a.acf.enddate >= a.acf.startdate &&
            a.acf.flyerposition === 'center' &&
            this.props.location.pathname === '/flyers-ca/center'
          ) {
            this.setState({
              bannerImageURL: a.acf.bannerca,
              flyerClassPoistion: 'flyer-center'
            });
          } else if (
            a.acf.isactive &&
            a.acf.issalelive === 'Yes' &&
            a.acf.startdate <= currentDate &&
            a.acf.enddate >= a.acf.startdate &&
            a.acf.flyerposition === 'right' &&
            this.props.location.pathname === '/flyers-ca/right'
          ) {
            this.setState({
              bannerImageURL: a.acf.bannerca,
              flyerClassPoistion: 'flyer-right'
            });
          } else if (
            a.acf.isactive &&
            a.acf.issalelive === 'Yes' &&
            a.acf.startdate <= currentDate &&
            a.acf.enddate >= a.acf.startdate &&
            a.acf.flyerposition === 'left' &&
            this.props.location.pathname === '/flyers-ca/left'
          ) {
            this.setState({
              bannerImageURL: a.acf.bannerca,
              flyerClassPoistion: 'flyer-left'
            });
          }
        } else if (i18n.language === 'fr-CA') {
          if (
            a.acf.isactive &&
            a.acf.issalelive === 'Yes' &&
            a.acf.startdate <= currentDate &&
            a.acf.enddate >= a.acf.startdate &&
            a.acf.flyerposition === 'center' &&
            this.props.location.pathname === '/flyers-ca/center'
          ) {
            this.setState({
              bannerImageURL: a.acf.bannerfr,
              flyerClassPoistion: 'flyer-center'
            });
          } else if (
            a.acf.isactive &&
            a.acf.issalelive === 'Yes' &&
            a.acf.startdate <= currentDate &&
            a.acf.enddate >= a.acf.startdate &&
            a.acf.flyerposition === 'right' &&
            this.props.location.pathname === '/flyers-ca/right'
          ) {
            this.setState({
              bannerImageURL: a.acf.bannerfr,
              flyerClassPoistion: 'flyer-right'
            });
          } else if (
            a.acf.isactive &&
            a.acf.issalelive === 'Yes' &&
            a.acf.startdate <= currentDate &&
            a.acf.enddate >= a.acf.startdate &&
            a.acf.flyerposition === 'left' &&
            this.props.location.pathname === '/flyers-ca/left'
          ) {
            this.setState({
              bannerImageURL: a.acf.bannerfr,
              flyerClassPoistion: 'flyer-right'
            });
          }
        } else {
          if (i18n.language === 'en-CA') {
            this.setState({
              bannerImageURL: this.BannerEnURL,
              flyerClassPoistion: 'flyer-normal'
            });
          } else {
            this.setState({
              bannerImageURL: this.BannerFrURL,
              flyerClassPoistion: 'flyer-normal'
            });
          }
        }
      });
      this.setState({ isLoading: false });
    });
  };

  private filterSections = (data: any) => {
    const cooking: any = data.filter((list: any) => {
      return list.product_section === 'cooking';
    });
    const washer: any = data.filter((list: any) => {
      return list.product_section === 'washer';
    });
    const dishwasher: any = data.filter((list: any) => {
      return list.product_section === 'dishwasher';
    });
    const dryer: any = data.filter((list: any) => {
      return list.product_section === 'dryer';
    });
    const hosesandconnectoer: any = data.filter((list: any) => {
      return list.product_section === 'hosesandconnectoer';
    });
    const earnmoreonservicecalls: any = data.filter((list: any) => {
      return list.product_section === 'earnmoreonservicecalls';
    });
    const christmasSpecials: any = data.filter((list: any) => {
      return list.product_section === 'christmasspecials';
    });
    const refrigerator: any = data.filter((list: any) => {
      return list.product_section === 'refrigerator';
    });
    const installation: any = data.filter((list: any) => {
      return list.product_section === 'installation';
    });
    const applianceCleaners: any = data.filter((list: any) => {
      return list.product_section === 'appliancecleaners';
    });

    this.setState({
      cooking,
      dishwasher,
      washer,
      dryer,
      hosesandconnectoer,
      earnmoreonservicecalls,
      christmasSpecials,
      refrigerator,
      installation,
      applianceCleaners
    });
  };

  private scrollspy = () => {
    const navLinks = document.querySelectorAll('.nav-item .nav-link');

    const navLinksArray: any = [];
    navLinks.forEach(navItem => navLinksArray.push(navItem));

    navLinksArray.forEach((navLink: any, index: any) => {
      navLink.addEventListener('click', (e: any) => {
        const elmt: any = document.getElementById(e.target.dataset.target);
        if (elmt) {
          elmt.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });

    const sections = document.querySelectorAll('.flyers-specials');

    const sectionArray: any = [];
    sections.forEach(section => sectionArray.push(section));

    const navbar = document.getElementById('navbar');

    const menuLinks = document.querySelectorAll('.nav-item .nav-link');

    const makeActive = (link: any) => menuLinks[link].classList.add('active');
    const removeActive = (link: any, index: number) =>
      menuLinks[index].classList.remove('active');
    const removeAllActive = () =>
      menuLinks.forEach((link, index) => removeActive(link, index));

    const sectionMargin = 70;

    let currentActive = 0;

    window.addEventListener('scroll', () => {
      if (window.scrollY >= navbar.offsetTop) {
        const current =
          sectionArray.length -
          [...sectionArray]
            .reverse()
            .findIndex(
              (section: any) =>
                window.scrollY >= section.offsetTop - sectionMargin
            ) -
          1;
        if (current !== currentActive) {
          removeAllActive();
          currentActive = current;
          makeActive(current);
        }
      }
    });
  };

  private reloadList = () => {
    this.getProducts();
  };

  public componentDidMount() {
    this.getProducts();
    this.getFlyBanners();
    window.addEventListener("scroll", this.handleScroll);
  }
  public componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  public handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop >=
      document.documentElement.offsetHeight - 1000
    ) {
      if(this.state.products.length===0){
        this.getProducts();  
      }else{
        this.getPriceList(this.state.products,'SCROLL');

      }
    }
  };

  private renderLoadingElements = () => {
    const items = [];
    let i = 0;
    while (i < 5) {
      items.push(
         <ProductCardLoading/>
      );
      i++;
    }
    return items;
  };

  public render() {
    const colourBg = {
      backgroundImage: `url(${this.GraphicBgURL}),linear-gradient(#124174,#1658a0)`,
      backgroundPosition: `97%`
    };
    const regBG = {
      backgroundImage: `url(${this.GraphicBgURL}),linear-gradient( 90deg, rgba(242, 243, 247, 1) 0%, rgba(201, 201, 201, 1) 100% )`,
      backgroundPosition: `97%`
    };
    return (
      <>


          {this.state.isLoading ? (
          <div className="loader-container">
            <div className="loader" />
          </div>
        ) :i18n.language === 'en-CA' ? (
          <div
            id="flyersbanner"
            className={this.state.flyerClassPoistion}
            style={{
              backgroundImage: `url(${this.state.bannerImageURL}`
            }}
          />
        ) : (
          <div
            id="flyersbanner"
            className={this.state.flyerClassPoistion}
            style={{
              backgroundImage: `url(${this.state.bannerImageURL}`
            }}
          />
        )}
       
          <div className="rp-flyersCa-section">
            <nav id="navbar" className="navbar">
              <ul className="navbar-nav mx-auto">
                {this.state.christmasSpecials.length > 0 && ( 
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      data-target="christmas-specials"
                    >
                      {i18n.t('flyers.christmasSpecials')}
                    </a>
                  </li>
                )}
                {this.state.cooking.length > 0 && (
                  <li className="nav-item">
                    <a className="nav-link" data-target="cooking-section">
                      {i18n.t('flyers.cooking')}
                    </a>
                  </li>
                )}
                {this.state.dishwasher.length > 0 && (
                  <li className="nav-item">
                    <a className="nav-link" data-target="dishwasher-section">
                      {i18n.t('flyers.dishwasher')}
                    </a>
                  </li>
                )}
                {this.state.dryer.length > 0 && (
                  <li className="nav-item">
                    <a className="nav-link" data-target="dryer-section">
                      {i18n.t('flyers.dryer')}
                    </a>
                  </li>
                )}
                {this.state.washer.length > 0 && (
                  <li className="nav-item">
                    <a className="nav-link" data-target="washer-section">
                      {i18n.t('flyers.washer')}
                    </a>
                  </li>
                )}
                {this.state.refrigerator.length > 0 && (
                  <li className="nav-item">
                    <a className="nav-link" data-target="refrigerator-section">
                      {i18n.t('flyers.refrigerator')}
                    </a>
                  </li>
                )}
                {this.state.installation.length > 0 && (
                  <li className="nav-item">
                    <a className="nav-link" data-target="installation-section">
                      {i18n.t('flyers.installation')}
                    </a>
                  </li>
                )}
                {this.state.applianceCleaners.length > 0 && (
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-target="applianceCleaners-section"
                    >
                      {i18n.t('flyers.applianceCleaners')}
                    </a>
                  </li>
                )}
                {/* <li className="nav-item">
                  <a
                    className="nav-link"
                    data-target="hosesandconnectoer-section"
                  >
                    {i18n.t('flyers.hosesConnectors')}
                  </a>
                </li> */}
                {this.state.earnmoreonservicecalls.length > 0 && (
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-target="earnmoreonservicecalls-section"
                    >
                      {i18n.t('flyers.earnMoreOnServiceCalls')}
                    </a>
                  </li>
                )}
              </ul>
            </nav>
              <div
                id="christmas-specials"
                className="christmas-specials flyers-specials"
                style={colourBg}
              >
                {this.state.priceList.length > 0 &&
                  this.state.priceList.map((product: any, index) => {
                    return (
                      <div key={index} className="card-container">
                        <ProductCard
                          section={true}
                          key={index}
                          part={product}
                          id={product.productNumber}
                          name={product.productNumber}
                          category={product.category}
                          mfc={product.manufacturerCode}
                          description={product.description}
                          price={product.partnerPrice}
                          msrp={product.retailPrice}
                          image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                          handleOnClicBuyNow={this.handleBuyNow}
                          handleToggleFavorite={this.handleToggleFavorite}
                          inStock={product.inStock}
                          isFavoriteLoading = {this.state.isFavoriteLoading}
                          selectedFavoriteItem = {this.state.selectedFavoriteItem}
                          favorite={product.favorite}
                          favoriteId={product.idFavoriteItem}
                          deal={!!product.discountInfo}
                          state={product.state}
                          stateDescription={product.stateDescription}
                          reloadPart={this.reloadList}
                          brand={product.brand}
                          viewDetails={product.view_details}
                        />
                      </div>
                    );
                  })}

                    {this.state.priceList.length ===0 && !this.state.hasMore && 
                    <div className='flyer-not-found'>{i18n.t('flyers.flyerPartsNotAvail')}</div>
                    }
                
                    { this.state.isProductDetailsLoading &&
                    <div className="rp-parts-flyer-grid">
                      {this.renderLoadingElements()}
                    </div>
                    }
              </div>
            {this.state.christmasSpecials.length > 0 && (
              <div
                id="christmas-specials"
                className="christmas-specials flyers-specials"
                style={colourBg}
              >
                {this.state.christmasSpecials.length > 0 &&
                  this.state.christmasSpecials.map((product: any, index) => {
                    return (
                      <div key={index} className="card-container">
                        <ProductCard
                          section={true}
                          key={index}
                          part={product}
                          id={product.productNumber}
                          name={product.productNumber}
                          category={product.category}
                          mfc={product.manufacturerCode}
                          description={product.description}
                          price={product.partnerPrice}
                          msrp={product.retailPrice}
                          image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                          handleOnClicBuyNow={this.handleBuyNow}
                          handleToggleFavorite={this.handleToggleFavorite}
                          inStock={product.inStock}
                          favorite={product.favorite}
                          favoriteId={product.idFavoriteItem}
                          deal={!!product.discountInfo}
                          state={product.state}
                          stateDescription={product.stateDescription}
                          reloadPart={this.reloadList}
                          brand={product.brand}
                          viewDetails={product.view_details}
                        />
                      </div>
                    );
                  })}
              </div>
            )}
            {this.state.cooking.length > 0 && (
              <div
                id="cooking-section"
                className="cooking-section flyers-specials"
                style={regBG}
              >
                {this.state.cooking.length > 0 &&
                  this.state.cooking.map((product: any, index) => {
                    return (
                      <div key={index} className="card-container">
                        <ProductCard
                          section={true}
                          key={index}
                          part={product}
                          id={product.productNumber}
                          name={product.productNumber}
                          category={product.category}
                          mfc={product.manufacturerCode}
                          description={product.description}
                          price={product.partnerPrice}
                          msrp={product.retailPrice}
                          image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                          handleOnClicBuyNow={this.handleBuyNow}
                          handleToggleFavorite={this.handleToggleFavorite}
                          inStock={product.inStock}
                          favorite={product.favorite}
                          favoriteId={product.idFavoriteItem}
                          deal={!!product.discountInfo}
                          state={product.state}
                          stateDescription={product.stateDescription}
                          reloadPart={this.reloadList}
                          brand={product.brand}
                          viewDetails={product.view_details}
                        />
                      </div>
                    );
                  })}
              </div>
            )}
            {/* {this.state.cooking.length > 0 && (
              <div
                id="cooking-section"
                className={`cooking-section flyers-specials`}
                style={regBG}
              >
                <div className="top-order">
                  {this.state.cooking
                    .slice(0, 1)
                    .map((product: any, index: number) => {
                      return (
                        <div
                          key={index}
                          className="card-container width50 flyer-cards"
                        >
                          <ProductCard
                            section={true}
                            key={index}
                            part={product}
                            id={product.productNumber}
                            name={product.productNumber}
                            mfc={product.manufacturerCode}
                            description={product.description}
                            price={product.partnerPrice}
                            msrp={product.retailPrice}
                            image={product.product_image}
                            handleOnClicBuyNow={this.handleBuyNow}
                            handleToggleFavorite={this.handleToggleFavorite}
                            inStock={product.inStock}
                            favorite={product.favorite}
                            favoriteId={product.idFavoriteItem}
                            deal={!!product.discountInfo}
                            state={product.state}
                            stateDescription={product.stateDescription}
                            reloadPart={this.reloadList}
                            brand={product.brand}
                            viewDetails={product.view_details}
                          />
                        </div>
                      );
                    })}
                  {this.state.cooking
                    .slice(1, 2)
                    .map((product: any, index: number) => {
                      return (
                        <div key={index} className="card-container width20">
                          <ProductCard
                            section={true}
                            key={index}
                            part={product}
                            id={product.productNumber}
                            name={product.productNumber}
                            mfc={product.manufacturerCode}
                            description={product.description}
                            price={product.partnerPrice}
                            msrp={product.retailPrice}
                            image={product.product_image}
                            handleOnClicBuyNow={this.handleBuyNow}
                            handleToggleFavorite={this.handleToggleFavorite}
                            inStock={product.inStock}
                            favorite={product.favorite}
                            favoriteId={product.idFavoriteItem}
                            deal={!!product.discountInfo}
                            state={product.state}
                            stateDescription={product.stateDescription}
                            reloadPart={this.reloadList}
                            brand={product.brand}
                            viewDetails={product.view_details}
                          />
                        </div>
                      );
                    })}
                  <div className="special-cards width30">
                    {this.state.cooking
                      .slice(2, 4)
                      .map((product: any, index: number) => {
                        return (
                          <div key={index} className="changeCards">
                            <ProductCard
                              section={true}
                              key={index}
                              part={product}
                              id={product.productNumber}
                              name={product.productNumber}
                              mfc={product.manufacturerCode}
                              description={product.description}
                              price={product.partnerPrice}
                              msrp={product.retailPrice}
                              image={product.product_image}
                              handleOnClicBuyNow={this.handleBuyNow}
                              handleToggleFavorite={this.handleToggleFavorite}
                              inStock={product.inStock}
                              favorite={product.favorite}
                              favoriteId={product.idFavoriteItem}
                              deal={!!product.discountInfo}
                              state={product.state}
                              stateDescription={product.stateDescription}
                              reloadPart={this.reloadList}
                              brand={product.brand}
                              viewDetails={product.view_details}
                            />
                          </div>
                        );
                      })}
                  </div>
                </div>
                {this.state.cooking.length > 4 &&
                  this.state.cooking
                    .slice(4, this.state.cooking.length - 1)
                    .map((product: any, index) => {
                      return (
                        <div key={index} className="card-container">
                          <ProductCard
                            section={true}
                            key={index}
                            part={product}
                            id={product.productNumber}
                            name={product.productNumber}
                            mfc={product.manufacturerCode}
                            description={product.description}
                            price={product.partnerPrice}
                            msrp={product.retailPrice}
                            image={product.product_image}
                            handleOnClicBuyNow={this.handleBuyNow}
                            handleToggleFavorite={this.handleToggleFavorite}
                            inStock={product.inStock}
                            favorite={product.favorite}
                            favoriteId={product.idFavoriteItem}
                            deal={!!product.discountInfo}
                            state={product.state}
                            stateDescription={product.stateDescription}
                            reloadPart={this.reloadList}
                            brand={product.brand}
                            viewDetails={product.view_details}
                          />
                        </div>
                      );
                    })}
              </div>
            )} */}
            {this.state.dishwasher.length > 0 && (
              <div
                id="dishwasher-section"
                className="dishwasher-section flyers-specials"
                style={colourBg}
              >
                {this.state.dishwasher.length > 0 &&
                  this.state.dishwasher.map((product: any, index) => {
                    return (
                      <div key={index} className="card-container">
                        <ProductCard
                          section={true}
                          key={index}
                          part={product}
                          id={product.productNumber}
                          name={product.productNumber}
                          category={product.category}
                          mfc={product.manufacturerCode}
                          description={product.description}
                          price={product.partnerPrice}
                          msrp={product.retailPrice}
                          image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                          handleOnClicBuyNow={this.handleBuyNow}
                          handleToggleFavorite={this.handleToggleFavorite}
                          inStock={product.inStock}
                          favorite={product.favorite}
                          favoriteId={product.idFavoriteItem}
                          deal={!!product.discountInfo}
                          state={product.state}
                          stateDescription={product.stateDescription}
                          reloadPart={this.reloadList}
                          brand={product.brand}
                          viewDetails={product.view_details}
                        />
                      </div>
                    );
                  })}
              </div>
            )}
            {this.state.dryer.length > 0 && (
              <div
                id="dryer-section"
                className={`dryer-section flyers-specials`}
                style={regBG}
              >
                {this.state.dryer.length > 0 &&
                  this.state.dryer.map((product: any, index) => {
                    return (
                      <div key={index} className="card-container">
                        <ProductCard
                          section={true}
                          key={index}
                          part={product}
                          id={product.productNumber}
                          name={product.productNumber}
                          category={product.category}
                          mfc={product.manufacturerCode}
                          description={product.description}
                          price={product.partnerPrice}
                          msrp={product.retailPrice}
                          image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                          handleOnClicBuyNow={this.handleBuyNow}
                          handleToggleFavorite={this.handleToggleFavorite}
                          inStock={product.inStock}
                          favorite={product.favorite}
                          favoriteId={product.idFavoriteItem}
                          deal={!!product.discountInfo}
                          state={product.state}
                          stateDescription={product.stateDescription}
                          reloadPart={this.reloadList}
                          brand={product.brand}
                          viewDetails={product.view_details}
                        />
                      </div>
                    );
                  })}
              </div>
            )}
            {this.state.washer.length > 0 && (
              <div
                id="washer-section"
                className={`washer-section flyers-specials`}
                style={colourBg}
              >
                {this.state.washer.length > 0 &&
                  this.state.washer.map((product: any, index) => {
                    return (
                      <div key={index} className="card-container">
                        <ProductCard
                          section={true}
                          key={index}
                          part={product}
                          id={product.productNumber}
                          name={product.productNumber}
                          category={product.category}
                          mfc={product.manufacturerCode}
                          description={product.description}
                          price={product.partnerPrice}
                          msrp={product.retailPrice}
                          image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                          handleOnClicBuyNow={this.handleBuyNow}
                          handleToggleFavorite={this.handleToggleFavorite}
                          inStock={product.inStock}
                          favorite={product.favorite}
                          favoriteId={product.idFavoriteItem}
                          deal={!!product.discountInfo}
                          state={product.state}
                          stateDescription={product.stateDescription}
                          reloadPart={this.reloadList}
                          brand={product.brand}
                          viewDetails={product.view_details}
                        />
                      </div>
                    );
                  })}
              </div>
            )}

            {this.state.refrigerator.length > 0 && (
              <div
                id="refrigerator-section"
                className={`refrigerator-section flyers-specials`}
                style={regBG}
              >
                {this.state.refrigerator.length > 0 &&
                  this.state.refrigerator.map((product: any, index) => {
                    return (
                      <div key={index} className="card-container">
                        <ProductCard
                          section={true}
                          key={index}
                          part={product}
                          id={product.productNumber}
                          name={product.productNumber}
                          category={product.category}
                          mfc={product.manufacturerCode}
                          description={product.description}
                          price={product.partnerPrice}
                          msrp={product.retailPrice}
                          image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                          handleOnClicBuyNow={this.handleBuyNow}
                          handleToggleFavorite={this.handleToggleFavorite}
                          inStock={product.inStock}
                          favorite={product.favorite}
                          favoriteId={product.idFavoriteItem}
                          deal={!!product.discountInfo}
                          state={product.state}
                          stateDescription={product.stateDescription}
                          reloadPart={this.reloadList}
                          brand={product.brand}
                          viewDetails={product.view_details}
                        />
                      </div>
                    );
                  })}
              </div>
            )}
            {this.state.installation.length > 0 && (
              <div
                id="installation-section"
                className={`installation-section flyers-specials`}
                style={colourBg}
              >
                {this.state.installation.length > 0 &&
                  this.state.installation.map((product: any, index) => {
                    return (
                      <div key={index} className="card-container">
                        <ProductCard
                          section={true}
                          key={index}
                          part={product}
                          id={product.productNumber}
                          name={product.productNumber}
                          category={product.category}
                          mfc={product.manufacturerCode}
                          description={product.description}
                          price={product.partnerPrice}
                          msrp={product.retailPrice}
                          image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                          handleOnClicBuyNow={this.handleBuyNow}
                          handleToggleFavorite={this.handleToggleFavorite}
                          inStock={product.inStock}
                          favorite={product.favorite}
                          favoriteId={product.idFavoriteItem}
                          deal={!!product.discountInfo}
                          state={product.state}
                          stateDescription={product.stateDescription}
                          reloadPart={this.reloadList}
                          brand={product.brand}
                          viewDetails={product.view_details}
                        />
                      </div>
                    );
                  })}
              </div>
            )}
            {this.state.applianceCleaners.length > 0 && (
              <div
                id="applianceCleaners-section"
                className={`applianceCleaners-section flyers-specials`}
                style={regBG}
              >
                {this.state.applianceCleaners.length > 0 &&
                  this.state.applianceCleaners.map((product: any, index) => {
                    return (
                      <div key={index} className="card-container">
                        <ProductCard
                          section={true}
                          key={index}
                          part={product}
                          id={product.productNumber}
                          name={product.productNumber}
                          category={product.category}
                          mfc={product.manufacturerCode}
                          description={product.description}
                          price={product.partnerPrice}
                          msrp={product.retailPrice}
                          image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                          handleOnClicBuyNow={this.handleBuyNow}
                          handleToggleFavorite={this.handleToggleFavorite}
                          inStock={product.inStock}
                          favorite={product.favorite}
                          favoriteId={product.idFavoriteItem}
                          deal={!!product.discountInfo}
                          state={product.state}
                          stateDescription={product.stateDescription}
                          reloadPart={this.reloadList}
                          brand={product.brand}
                          viewDetails={product.view_details}
                        />
                      </div>
                    );
                  })}
              </div>
            )}

            {/* {this.state.hosesandconnectoer.length > 0 && (
              <div
                id="hosesandconnectoer-section"
                className="hosesandconnectoer-section flyers-specials"
                style={regBG}
              >
                {this.state.hosesandconnectoer.length > 0 &&
                  this.state.hosesandconnectoer.map((product: any, index) => {
                    return (
                      <div key={index} className="card-container">
                        <ProductCard
                          section={true}
                          key={index}
                          part={product}
                          id={product.productNumber}
                          name={product.productNumber}
                          mfc={product.manufacturerCode}
                          description={product.description}
                          price={product.partnerPrice}
                          msrp={product.retailPrice}
                          image={product.product_image}
                          handleOnClicBuyNow={this.handleBuyNow}
                          handleToggleFavorite={this.handleToggleFavorite}
                          inStock={product.inStock}
                          favorite={product.favorite}
                          favoriteId={product.idFavoriteItem}
                          deal={!!product.discountInfo}
                          state={product.state}
                          stateDescription={product.stateDescription}
                          reloadPart={this.reloadList}
                          brand={product.brand}
                          viewDetails={product.view_details}
                        />
                      </div>
                    );
                  })}
              </div>
            )} */}
            {this.state.earnmoreonservicecalls.length > 0 && (
              <div
                id="earnmoreonservicecalls-section"
                className="earnmoreonservicecalls-section flyers-specials"
                style={colourBg}
              >
                {this.state.earnmoreonservicecalls.length > 0 &&
                  this.state.earnmoreonservicecalls.map(
                    (product: any, index) => {
                      return (
                        <div key={index} className="card-container">
                          <ProductCard
                            section={true}
                            key={index}
                            part={product}
                            id={product.productNumber}
                            name={product.productNumber}
                            category={product.category}
                            mfc={product.manufacturerCode}
                            description={product.description}
                            price={product.partnerPrice}
                            msrp={product.retailPrice}
                            image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                            handleOnClicBuyNow={this.handleBuyNow}
                            handleToggleFavorite={this.handleToggleFavorite}
                            inStock={product.inStock}
                            favorite={product.favorite}
                            favoriteId={product.idFavoriteItem}
                            deal={!!product.discountInfo}
                            state={product.state}
                            stateDescription={product.stateDescription}
                            reloadPart={this.reloadList}
                            brand={product.brand}
                            viewDetails={product.view_details}
                          />
                        </div>
                      );
                    }
                  )}
              </div>
            )}
            <div className="individual-card-container">
              {this.individualCards.map((product: any, index: number) => {
                return (
                  <IndividualCard
                    key={index}
                    label={product.label}
                    imageUrl={product.imageUrl}
                    buttonText={product.buttonText}
                    backgroundURl={product.backgroundURl}
                    cardName={product.cardName}
                    buttonLink={product.buttonLink}
                  />
                );
              })}
            </div>
            <div className="signup-parent">
              <div className="signup-option-wrapper">
                <div className="signup-option">
                  <p className="signup-label">
                    {i18n.t('flyers.getAllTheLatestDealsInYourInbox')}
                  </p>
                  <button className="signup-submit">
                    <a
                      href={
                        i18n.language === 'fr-CA'
                          ? 'http://eepurl.com/cqlydf'
                          : 'http://eepurl.com/drRxqb'
                      }
                    >
                      {i18n.t('flyers.getDeals')}
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
      </>
    );
  }
}

export default FlyersCa;
